<template>
  <div id="MFooterNav" class="mobilePage">
    <div class="footerPanel">
      <div class="footerContentPanel">
        <img style="width: 2.23rem" src="@/images/title/contactUs.png" />
        <div class="meetingDetailsPanel flex-start-start">
          <div class="meetingAddressPanel">
            <div class="meetingAddressTitle flex-center-start">
              <img
                class="meetingAddressIcon"
                src="@/images/com/address_orange_icon.png"
                alt
              />
              <span class="meetingDetailsText">会议地点</span>
            </div>
            <div class="meetingAddressContent meetingDetailsContent">
              中国·深圳 深圳湾万丽酒店3F
            </div>
          </div>
          <div class="meetingTimePanel">
            <div class="meetingTimeTitle flex-center-start">
              <img
                class="meetingTimeIcon"
                src="@/images/com/time_orange_icon.png"
                alt
              />
              <span class="meetingDetailsText">会议时间</span>
            </div>
            <div class="meetingTimeContent meetingDetailsContent">
              2025/12/05
            </div>
          </div>
        </div>
        <div class="mCooperationPanel"><mCooperation /></div>
      </div>
      <div class="keep-on-record">
        版权所有：深圳市游迷天下科技有限公司 <br />法律声明
        <a target="_blank" href="http://beian.miit.gov.cn/"
          >粤ICP备13090461号</a
        >
      </div>
    </div>
  </div>
</template>
<script>
import titleBox from "@/components/titleBox.vue";
import mCooperation from "@/components/m/mCooperation.vue";
export default {
  components: {
    titleBox,
    mCooperation,
  },
  data() {
    return {
      show: false,
    };
  },

  methods: {
    showPopup() {
      this.show = true;
    },
  },
};
</script>
<style lang="scss" scoped>
#MFooterNav {
  .footerPanel {
    width: 100%;
    padding: 0.6rem 0 0.9rem 0;
    background: linear-gradient(60deg, #010412 0%, #400104 100%);
  }
  .footerContentPanel {
    padding: 0 0.4rem;
  }
  //   会议相关
  .meetingDetailsPanel {
    padding-top: 0.5rem;
  }
  .meetingTimePanel {
    max-width: 2.88rem;
  }
  .meetingAddressPanel {
    max-width: 3.6rem;
    margin-right: 1rem;
  }

  .meetingAddressIcon {
    width: 0.2rem;
    height: 0.24rem;
  }
  .meetingTimeIcon {
    width: 0.24rem;
    height: 0.24rem;
  }
  .meetingDetailsText {
    font-size: 0.24rem;
    font-weight: 400;
    color: #fff;
    padding-left: 0.12rem;
  }

  .meetingDetailsContent {
    font-size: 0.24rem;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.6);
    padding-top: 0.18rem;
  }
  .mCooperationPanel {
    margin-top: 0.86rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/m/com/mFooterNav.vue